import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const DescargarPostulacionesZip = ({ formularioId }) => {
  const BASE_URL = "https://wwwa.isepsantafe.net.ar/expedientes/";
  const [descargando, setDescargando] = useState(false);
  const [dnisTexto, setDnisTexto] = useState("");

  const parsearDnis = () => {
    return dnisTexto
      .split(/[\s,;\n\r]+/)
      .map((d) => d.trim())
      .filter(Boolean);
  };

  const descargarZip = async () => {
    if (!formularioId) {
      return Swal.fire("Error", "Falta formulario_id", "error");
    }

    const dnis = parsearDnis();

    try {
      setDescargando(true);

      Swal.fire({
        title: "Generando ZIP...",
        text: dnis.length
          ? `Generando formularios para ${dnis.length} DNI.`
          : "Generando todos los formularios. Esto puede demorar.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await axios({
        method: "post",
        url: `${BASE_URL}ingresos/descargarPostulacionesZip`,
        data: {
          formulario_id: 1,
          limit: dnis.length ? dnis.length : 100000,
          dnis,
        },
        responseType: "blob",
        timeout: 0,
      });

      const blob =
        response.data instanceof Blob
          ? response.data
          : new Blob([response.data], { type: "application/zip" });

      if (!blob || blob.size === 0) {
        throw new Error("El ZIP vino vacío");
      }

      if (
        blob.type.includes("application/json") ||
        blob.type.includes("text/html")
      ) {
        const texto = await blob.text();
        console.error("Respuesta no ZIP:", texto);
        throw new Error("El servidor devolvió un error, no un ZIP.");
      }

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = dnis.length
        ? `postulaciones_formulario_${formularioId}_segmentado.zip`
        : `postulaciones_formulario_${formularioId}.zip`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

      Swal.close();

      Swal.fire("ZIP generado", "Se descargó correctamente.", "success");
    } catch (error) {
      console.error("Error descargando ZIP:", error);

      Swal.fire(
        "Error",
        error.message || "No se pudo generar el ZIP.",
        "error"
      );
    } finally {
      setDescargando(false);
    }
  };

  return (
    <div className="card p-3">
      <label className="form-label fw-bold">
        DNIs a descargar (opcional)
      </label>

      <textarea
        className="form-control mb-2"
        rows={5}
        placeholder={`Pegá los DNI separados por coma, espacio o salto de línea.
Si lo dejás vacío, descarga todos.`}
        value={dnisTexto}
        onChange={(e) => setDnisTexto(e.target.value)}
        disabled={descargando}
      />

      <button
        type="button"
        className="btn btn-success"
        onClick={descargarZip}
        disabled={descargando}
      >
        {descargando ? "Generando ZIP..." : "📦 Descargar formularios ZIP"}
      </button>
    </div>
  );
};

export default DescargarPostulacionesZip;